<template>
  <v-container
    fluid
    grid-list-md
  >
    <inventory-counts-counter :uuid="uuid" />
  </v-container>
</template>

<script>
import Vue from 'vue'
import InventoryCountsCounter from '@/components/inventory-counts/InventoryCountsCounter.vue'

export default {
  metaInfo () {
    return { title: this.pageTitle }
  },

  components: {
    InventoryCountsCounter
  },

  data: () => ({
    pageTitle: Vue.i18n.translate('Inventory Count')
  }),

  computed: {
    uuid () {
      return this.$route.params.uuid
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/inventory-counts/Counter.vue